import React, { Children, useState, useEffect, Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import BusinessApi from 'apis/Business';
import Toaster from 'components/Toaster';

import 'assets/scss/components/locationModal.css';
import StepsIndicator from 'components/creditCard/stepsIndicator';
import CreditCardForm from 'components/Form/payment/creditCardForm';
import BillingAddressForm from 'components/Form/payment/billingAddress';

export const MODAL_CONTENT = [
  {
    name: 'Card Details',
  },
  {
    name: 'Billing Details',
  },
  {
    name: 'Confirmation',
  },
];

const AddCreditCardModal = ({
  isVisible,
  onCancel,
  toggleSuccessModal,
  businessId,
  billingAddresses,
  editModal,
  billingCardId,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [cardDetails, setCardDetails] = useState({});
  const [billingAddress, setBillingAddress] = useState({});
  const isPrimary = !(billingAddresses && billingAddresses.length > 0);

  useEffect(() => {
    setCurrentStep(0);
  }, [isVisible]);

  const saveBillingAddress = values => {
    const billingAddressAttribute = {
      ...values,
      billing_name: cardDetails.billing_name,
      state: values.state.values,
      nonce: cardDetails.nonce,
      is_primary: isPrimary,
    };
    if (editModal && billingCardId) billingAddressAttribute.id = billingCardId;
    const billing_addresses_attributes = [billingAddressAttribute];
    const updateData = {
      business: {
        billing_addresses_attributes,
      },
    };
    BusinessApi.update(businessId, updateData)
      .then(({ data }) => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully added credit card'
        );
        toggleSuccessModal();
        onCancel();
      })
      .catch(() => {
        Toaster.getErrorToaster('exclamation-triangle', 'Failed to add card');
      });
  };

  const handleNext = values => {
    if (currentStep === MODAL_CONTENT.length - 2) {
      saveBillingAddress(values);
    } else setCurrentStep(currentStep + 1);
  };

  const modalHeaderText = editModal ? 'Edit card' : 'Add a new card';

  return (
    <Modal
      className="location-modal credit-card-modal"
      isOpen={isVisible}
      toggle={onCancel}
      onClickBackdrop={onCancel}
    >
      <ModalHeader className="text-center">
        <div className="modal-title d-inline text-bold">{modalHeaderText}</div>
        <span role="none" className="close-modal" onClick={onCancel}>
          <FontAwesomeIcon icon="times" />
        </span>
      </ModalHeader>
      <ModalBody className="pt-3 pb-0 pl-4 pr-4">
        <StepsIndicator currentStep={currentStep} />
        {currentStep === 0 && (
          <CreditCardForm
            handleNext={handleNext}
            onCancel={onCancel}
            setCardDetails={setCardDetails}
          />
        )}
        {currentStep === 1 && (
          <BillingAddressForm
            handleNext={handleNext}
            onCancel={onCancel}
            setBillingAddress={setBillingAddress}
            cardDetails={cardDetails}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

AddCreditCardModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleSuccessModal: PropTypes.func.isRequired,
};

export default AddCreditCardModal;



// WEBPACK FOOTER //
// ./src/components/Modal/creditCard/addCreditCard.js